module.exports = __webpack_public_path__ + "img/Ellipse_30.471d564d.svg";